import PropTypes from "prop-types";
import { useCallback, useState } from "react";
import { BrowserRouter, Route } from "react-router-dom";

import ScrollToTop from "components/scroll-to-top";

import CheckCode from "./check-code";
import CheckPostcode from "./check-postcode";
import EnterEmail from "./enter-email";
import EnterNumber from "./enter-number";
import UidEmail from "./uid-email";

const Login = ({ identifiedUser = {}, turnstileEnabled }) => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [normalizedMobileNumber, setNormalizedMobileNumber] = useState("");
  const [channelKey, setChannelKey] = useState();
  const [restartFlowErrors, setRestartFlowErrors] = useState();

  const restartFlow = useCallback((errors, history) => {
    setRestartFlowErrors(errors);
    history.push("/");
  }, []);

  const handleMobileNumberChange = (e) => setMobileNumber(e.target.value);

  const handleSuccess = ({
    channelKey: newChannelKey,
    mobileNumber: newMobileNumber,
  }) => {
    setChannelKey(newChannelKey);
    setNormalizedMobileNumber(newMobileNumber);
  };

  return (
    <BrowserRouter basename="/account/login">
      <ScrollToTop>
        <Route exact path="/">
          <EnterNumber
            initialErrors={restartFlowErrors}
            mobileNumber={mobileNumber}
            turnstileEnabled={turnstileEnabled}
            onMobileNumberChange={handleMobileNumberChange}
            onSuccess={handleSuccess}
          />
        </Route>
        <Route exact path="/check">
          <CheckCode
            channelKey={channelKey}
            mobileNumber={normalizedMobileNumber}
            restartFlow={restartFlow}
          />
        </Route>
        <Route exact path="/verify">
          <CheckPostcode
            channelKey={channelKey}
            mobileNumber={normalizedMobileNumber}
            restartFlow={restartFlow}
          />
        </Route>
        <Route exact path="/email">
          <EnterEmail />
        </Route>
        <Route exact path="/uid-email">
          <UidEmail identifiedUser={identifiedUser} />
        </Route>
        <Route exact path="/uid-email-sent">
          <UidEmail identifiedUser={identifiedUser} />
        </Route>
      </ScrollToTop>
    </BrowserRouter>
  );
};

Login.propTypes = {
  turnstileEnabled: PropTypes.bool.isRequired,
  identifiedUser: PropTypes.object,
};

export default Login;
